export const authActions = {
  login: (payload) => ({
    type: 'login.fetch',
    payload,
  }),
  loginSuccess: (payload) => ({
    type: 'login.success',
    payload,
  }),
  loginFailure: (payload) => ({
    type: 'login.failure',
    payload,
  }),
  logout: () => ({
    type: 'logout',
  }),
  logoutSuccess: (payload) => ({
    type: 'logout.success',
    payload,
  }),
  logoutFailure: (payload) => ({
    type: 'logout.failure',
    payload,
  }),

  sendForgotPasswordEmail: (payload) => ({
    type: 'sendForgotPasswordEmail',
    payload,
  }),
  sendForgotPasswordEmailSuccess: (payload) => ({
    type: 'sendForgotPasswordEmail.success',
    payload,
  }),
  sendForgotPasswordEmailFailure: (payload) => ({
    type: 'sendForgotPasswordEmail.failure',
    payload,
  }),

  changePassword: (payload) => ({
    type: 'changepassword',
    payload,
  }),
  changePasswordSuccess: (payload) => ({
    type: 'changepassword.success',
    payload,
  }),
  changePasswordFailure: (payload) => ({
    type: 'changepassword.failure',
    payload,
  }),

  userNeedsToConfirmProfileInformation: () => ({
    type: 'userNeedsToConfirmProfileInformation',
  }),
  userConfirmedProfileInformation: (payload) => ({
    type: 'userConfirmedProfileInformation',
    payload,
  }),
  userConfirmedProfileInformationSuccess: () => ({
    type: 'userConfirmedProfileInformation.success',
  }),
  userConfirmedProfileInformationError: () => ({
    type: 'userConfirmedProfileInformation.error',
  }),
};
